




















import Vue from 'vue'

interface Computed {
  estadoInterno: boolean;
}

interface Props {
  value: boolean;
  legendaInativo: string;
  legendaAtivo: string;
  mostrarDetalhes: boolean;
  desativado: boolean;

}

export default Vue.extend<{}, {}, Computed, Props>({
  name: 'SliderAtivacao',

  props: {
    value: {
      type: Boolean,
      required: true
    },

    desativado: {
      type: Boolean,
      required: false
    },

    legendaInativo: {
      type: String,
      required: false,
      default: 'inativo'
    },
    legendaAtivo: {
      type: String,
      required: false,
      default: 'ativo'
    },
    mostrarDetalhes: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    estadoInterno: {
      get (): boolean {
        return this.value
      },
      set (estado): void {
        this.$emit('input', estado)
      }
    }
  }
})
